import React from 'react'
import { Box, Grid } from '@mui/material'
import { Button, Card, CardBody } from 'reactstrap'
import DeleteButton from '../Buttons/DeleteButton'
import EditButton from '../Buttons/EditButton'

const statusses = {
  overdue: {
    title: 'Myöhässä',
    icon: 'fa fa-exclamation-circle',
    color: 'red',
  },
  upcoming: { title: 'Tulossa', icon: 'fa fa-clock', color: 'orange' },
  done: { title: 'Aikataulussa', icon: 'fa fa-check-circle', color: 'green' },
}

const FREQS = {
  weekly: 'Viikoittain',
  biweekly: 'Kahden viikon välein',
  monthly: 'Kuukausittain',
  quarterly: 'Neljännesvuosittain',
  semiannually: 'Puolivuosittain',
  annually: 'Vuosittain',
  biennially: 'Kahden vuoden välein',
}

function MaintenanceCard({
  maintenance,
  onEdit,
  onDelete,
  onShowExecutions,
  onAddExecution,
  disabledActions,
}) {
  const status = statusses[maintenance.status]
  return (
    <Card
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <CardBody>
        <Grid container spacing={1}>
          <Grid size={{ xs: 6 }}>
            <h5>{maintenance.action}</h5>
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Box textAlign='right'>
              <span>
                <i
                  className={status?.icon}
                  style={{ color: status?.color, marginRight: 5 }}
                ></i>
                <h6 style={{ display: 'inline' }}>
                  {status?.title || maintenance.status}
                </h6>
              </span>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <strong>Kohde:</strong> {maintenance.target}
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <strong>Yksityiskohtainen kohde:</strong>{' '}
            {maintenance.detailedtarget}
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <strong>Aikataulu:</strong>{' '}
            {FREQS[maintenance.frequency] || maintenance.frequency}
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <strong>Vastaava:</strong> {maintenance.responsible}
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <strong>Seuraava kerta:</strong>{' '}
            {maintenance.nextduedate && maintenance.nextduedate.toDate ? maintenance.nextduedate.toDate().toLocaleDateString() : new Date(maintenance.nextduedate).toLocaleDateString()}
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <strong>Viimeisin suoritus:</strong>{' '}
            {maintenance.lastcompletiondate && maintenance.lastcompletiondate.toDate ? maintenance.lastcompletiondate.toDate().toLocaleDateString() : new Date(maintenance.lastcompletiondate).toLocaleDateString()}
          </Grid>
          <Grid size={{ xs: 12 }}>
            <strong>Huomiot/Ohjeet</strong>
            <br /> {maintenance.notes}
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Button
              disabled={disabledActions}
              color='primary'
              size='sm'
              onClick={() => onAddExecution(maintenance.id)}
            >
              Lisää suoritus
            </Button>{' '}
            <Button
              disabled={disabledActions}
              color='info'
              size='sm'
              onClick={() => onShowExecutions(maintenance.id)}
            >
              Näytä suoritukset
            </Button>{' '}
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box textAlign='right'>
            <EditButton size='sm' onClick={() => onEdit(maintenance.id)} disablediv={true} loading={disabledActions} />{' '}
            <DeleteButton
              size='sm'
              onClick={() => onDelete(maintenance.id)}
              style={{ marginLeft: 5 }}
                disablediv={true}
              loading={disabledActions}
            />
            </Box>
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

function CardGrid({
  cards,
  columns,
  onEdit,
  onDelete,
  onShowExecutions,
  onAddExecution,
}) {
  const columnClass = `col-md-${12 / columns} mb-1`
  return (
    <Grid container spacing={1}>
      {cards.map((card, index) => (
        <Grid size={{ xs: 12 / columns }} key={index}>
          <div className={columnClass}>
            <MaintenanceCard
              maintenance={card}
              onEdit={onEdit}
              onDelete={onDelete}
              onShowExecutions={onShowExecutions}
              onAddExecution={onAddExecution}
            />
          </div>
        </Grid>
      ))}
    </Grid>
  )
}

export default CardGrid
